import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./solutions.css";
import AutoTyping, { BlinkCursor } from "react-auto-typing";

import cubixImage from "../../assets/cubix.png";
import trackLine from "../../assets/trackline.jpeg";
import onService from "../../assets/onservice.jpeg";
import activ from "../../assets/activ.jpeg";
import relationManagement from "../../assets/relationmanagement.png";
import aristi from "../../assets/aristi.jpg";
import { Dots } from "react-dot-patterns";

const Solutions = () => {
  return (
    <div className="solutions-wrapper">
      <div className="dots1">
        <Dots
          col={5}
          row={4}
          size={5}
          rotate={90}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={15}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={5}
          row={3}
          size={5}
          rotate={90}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">Featured Solutions</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Solutions"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="solutions-gallery">
        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            type: "bullets",
          }}
          speed={500}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className="mySwiper"
          breakpoints={{
            768: {
              slidesPerView: "auto",
            },
          }}
        >
          <SwiperSlide
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${cubixImage}) no-repeat`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="text-box inverse text-center">
              <h3 className="h1 heading-underline text-center">Cubix</h3>
              <p>
                CUBIX is a comprehensive warehouse management software designed
                to streamline inventory control, optimize warehouse operations,
                and enhance productivity. It offers real-time inventory
                tracking, multi-location support, and flexible reporting,
                ensuring efficient and accurate management of all warehouse
                activities.
              </p>
              <a
                href="#"
                target="_blank"
                rel="noopener"
                className="btn btn-outline-secondary  inverse "
              >
                Learn more
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${trackLine}) no-repeat`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="text-box inverse text-center">
              <h3 className="h1 heading-underline text-center">Trackline</h3>
              <p>
                Trackline is a comprehensive asset management software
                specifically designed to streamline the tracking, maintenance,
                and lifecycle management of company assets across various
                industries. The software leverages advanced barcode and RFID
                technology to capture and maintain detailed information about
                each asset, from initial procurement to deployment at specific
                sites or branches.
              </p>
              <a
                href="#"
                target="_blank"
                rel="noopener"
                className="btn btn-outline-secondary  inverse "
              >
                Learn more
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${onService}) no-repeat`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="text-box inverse text-center">
              <h3 className="h1 heading-underline text-center">On-Service</h3>
              <p>
                OnService empowers service providers worldwide with streamlined
                hardware repair and maintenance solutions. Simplifying workforce
                management from routine to emergency tasks, it ensures smooth
                operations, minimizes downtime, and boosts productivity.
                Real-time monitoring, automated reminders, and detailed employee
                reporting enable teams to proactively manage challenges and
                optimize performance, fostering stronger client relationships.
              </p>
              <a
                href="#"
                target="_blank"
                rel="noopener"
                className="btn btn-outline-secondary  inverse "
              >
                Learn more
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${activ}) no-repeat`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="text-box inverse text-center">
              <h3 className="h1 heading-underline text-center">Activ</h3>
              <p>
                HR payroll software streamlines and automates payroll processes,
                ensuring compliance with regulations while reducing costs. It
                integrates payroll, tax, direct deposit, and self-service
                features, improving accuracy and employee satisfaction. With
                customizable settings, HR and accounting integration, and strong
                security, it's a key tool for efficient HR management.
              </p>
              <a
                href="#"
                target="_blank"
                rel="noopener"
                className="btn btn-outline-secondary  inverse "
              >
                Learn more
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${relationManagement}) no-repeat`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="text-box inverse text-center">
              <h3 className="h1 heading-underline text-center">RM connect</h3>
              <p>
                RM Connect is designed to enhance the effectiveness of
                relationship managers by "providing advanced insights,"
                "streamlining client interactions," or "facilitating
                personalized service delivery".
              </p>
              <a
                href="#"
                target="_blank"
                rel="noopener"
                className="btn btn-outline-secondary  inverse "
              >
                Learn more
              </a>
            </div>
          </SwiperSlide>
          <SwiperSlide
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${aristi}) no-repeat`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="text-box inverse text-center">
              <h3 className="h1 heading-underline text-center">Aristi</h3>
              <p>
                ARISTI captures the fingerprints of the user. ARISTI verifies
                the fingerprint of the user. After verification, ARISTI notifies
                the System.
              </p>
              <a
                href="#"
                target="_blank"
                rel="noopener"
                className="btn btn-outline-secondary  inverse "
              >
                Learn more
              </a>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Solutions;
